export const musicProviders = {
  spotify: {
    short: "s",
    title: "Spotify",
    thumbnailSupport: true,
  },
  itunes: {
    short: "i",
    title: "Apple Music",
    thumbnailSupport: true,
  },
  youtube: {
    short: "y",
    title: "YouTube Music",
    thumbnailSupport: true,
  },
  pandora: {
    short: "p",
    title: "Pandora",
    thumbnailSupport: false,
  },
  deezer: {
    short: "d",
    title: "Deezer",
    thumbnailSupport: false,
  },
  soundcloud: {
    short: "sc",
    title: "SoundCloud",
    thumbnailSupport: true,
  },
  amazon: {
    short: "a",
    title: "Amazon Music",
    thumbnailSupport: true,
  },
  tidal: {
    short: "t",
    title: "Tidal",
    thumbnailSupport: true,
  },
  napster: {
    short: "n",
    title: "Napster",
    thumbnailSupport: false,
  },
  yandex: {
    short: "ya",
    title: "Yandex Music",
    thumbnailSupport: false,
  },
  audiomack: {
    short: "am",
    title: "Audiomack",
    thumbnailSupport: false,
  },
  boomplay: {
    short: "bp",
    title: "Boomplay",
    thumbnailSupport: false,
  },
} as const;
